import { FormEvent, useState } from "react";
import "./styles/components/auth.css";

type LoginPageProps = {
  error: string | null;
  onLogin: (username: string, password: string) => Promise<void>;
};

export function LoginPage({ error, onLogin }: LoginPageProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!username.trim() || !password) {
      setFormError("Enter username and password");
      return;
    }
    setSubmitting(true);
    setFormError(null);
    try {
      await onLogin(username.trim(), password);
    } catch (err) {
      setFormError(err instanceof Error ? err.message : "Sign in failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-shell">
      <section className="login-panel" aria-labelledby="login-title">
        <div className="login-brand">
          <div className="login-mark">
            <img src="/te-mark.svg" alt="Tactical Edge" width={48} height={49} />
          </div>
          <h1 id="login-title" className="login-wordmark">DRAIDIS</h1>
          <p className="login-kicker">Tactical Edge · Operational Risk Board</p>
        </div>

        <div className="login-rule" />

        <div className="login-status" role="status">
          <span className="login-status-dot" aria-hidden="true" />
          System Online
          <span className="login-status-sep" aria-hidden="true" />
          <span className="login-status-env">ellsworth · orm</span>
        </div>

        <form className="login-form" onSubmit={submit}>
          <label>
            <span>Username</span>
            <input
              autoComplete="username"
              autoFocus
              name="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </label>
          <label>
            <span>Password</span>
            <input
              autoComplete="current-password"
              name="password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          {formError || error ? (
            <div className="login-error" role="alert">
              {formError ?? error}
            </div>
          ) : null}
          <button type="submit" className="login-submit" disabled={submitting}>
            {submitting ? (
              "Signing in…"
            ) : (
              <>
                Sign in
                <span className="login-submit-arrow" aria-hidden="true">
                  &rarr;
                </span>
              </>
            )}
          </button>
        </form>

        <div className="login-meta">AI for the Warfighter</div>
      </section>
    </main>
  );
}
